import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { validate, mergeStyles, getRelValue, addAnchorTagToUrl, anchorScroll, normalizeHref, ANCHOR_VIEWER_DATA_HOOK, LINK_VIEWER_DATA_HOOK } from 'wix-rich-content-common';
import pluginLinkSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-link.schema.json';
import { isEqual } from 'lodash';
import { Decoration_Type } from 'ricos-schema';

const EXTERNAL_LINK_TYPE = "wix-draft-plugin-external-link";
const LINK_TYPE = "LINK";
const ANCHOR_TYPE = "ANCHOR";
const CUSTOM_LINK_TYPE = "ricos-plugin-custom-link";

var styles = {"fontElementMap":"M6VRD","link":"mjd-9","linkInEditor":"AAa83","linkInViewer":"d7-DH","toolbarUrlContainer":"iufOm","toolbarUrl":"dD1j2","toolbarUrlAnchor":"rI-A9"};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class LinkViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleClick", (event) => {
      var _a;
      const { componentData, isInEditor, config, helpers, customAnchorScroll } = this.props;
      const settings = config == null ? void 0 : config[LINK_TYPE];
      if (settings) {
        const { onClick } = settings;
        const { anchor, url } = componentData;
        (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, LINK_TYPE, "Click", componentData);
        onClick == null ? void 0 : onClick(event, (componentData == null ? void 0 : componentData.customData) || this.getHref(url, anchor));
        if (anchor) {
          event.stopPropagation();
          if (!isInEditor) {
            event.preventDefault();
            if (customAnchorScroll) {
              customAnchorScroll(event, anchor);
            } else {
              const anchorString = `viewer-${anchor}`;
              const element = document.getElementById(anchorString);
              addAnchorTagToUrl(anchorString);
              anchorScroll(element);
            }
          }
        }
      }
    });
    __publicField(this, "getHref", (url, anchor) => url ? normalizeHref(url) : `#viewer-${anchor}`);
    validate(props.componentData, pluginLinkSchema);
    const theme = this.props.theme;
    this.styles = mergeStyles({ styles, theme });
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginLinkSchema);
    }
  }
  render() {
    const { componentData, anchorTarget, children, isInEditor } = this.props;
    const { url, anchor, target = anchorTarget, rel } = componentData;
    const anchorProps = {
      href: this.getHref(url, anchor),
      target: anchor ? "_self" : target,
      rel: getRelValue(rel),
      className: classNames(this.styles.link, {
        [this.styles.linkInEditor]: isInEditor,
        [this.styles.linkInViewer]: !isInEditor
      }),
      onClick: this.handleClick
    };
    const dataHook = anchor ? ANCHOR_VIEWER_DATA_HOOK : LINK_VIEWER_DATA_HOOK;
    return /* @__PURE__ */ React.createElement("a", __spreadValues$1({ "data-hook": dataHook }, anchorProps), children);
  }
}
__publicField(LinkViewer, "propTypes", {
  componentData: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  anchorTarget: PropTypes.string,
  relValue: PropTypes.string,
  customAnchorScroll: PropTypes.func,
  settings: PropTypes.object,
  isInEditor: PropTypes.bool,
  config: PropTypes.object,
  helpers: PropTypes.object
});
var LinkViewer$1 = LinkViewer;

const typeMapper = () => ({
  [EXTERNAL_LINK_TYPE]: { component: LinkViewer$1, elementType: "inline" },
  [LINK_TYPE]: { component: LinkViewer$1, elementType: "inline" },
  [ANCHOR_TYPE]: { component: LinkViewer$1, elementType: "inline" },
  [CUSTOM_LINK_TYPE]: { component: LinkViewer$1, elementType: "inline" }
});

const DEFAULTS = {
  config: { linkTypes: { anchor: true } }
};

const decorator$1 = (element, linkDecoration, contextualData) => {
  var _a;
  const { link: { url, target = contextualData.anchorTarget, rel = {} } = {} } = linkDecoration.linkData;
  let relValue = "noopener";
  rel.nofollow && (relValue += " nofollow");
  rel.sponsored && (relValue += " sponsored");
  rel.ugc && (relValue += " ugc");
  (rel.noreferrer || rel.noreferrer === void 0) && (relValue += " noreferrer");
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      key: `link=${element.key}`,
      target: `_${(_a = target == null ? void 0 : target.toLowerCase) == null ? void 0 : _a.call(target)}`,
      href: url && normalizeHref(url),
      rel: relValue,
      className: classNames(styles.link, styles.linkInViewer)
    },
    element
  );
};
const LinkDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.LINK));
  },
  decorate: ({ element, node, context }) => {
    var _a, _b;
    const linkDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.LINK
    );
    return decorator$1(element, linkDecoration, context);
  }
};

const decorator = (anchorDecoration, element) => {
  const { anchor } = anchorDecoration.anchorData;
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      key: `anchor-${element == null ? void 0 : element.key}`,
      target: "_self",
      href: `#viewer-${anchor}`,
      className: classNames(styles.link, styles.linkInViewer),
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        const anchorString = `viewer-${anchor}`;
        const element2 = document.getElementById(anchorString);
        addAnchorTagToUrl(anchorString);
        anchorScroll(element2);
      }
    },
    element
  );
};
const AnchorDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.ANCHOR));
  },
  decorate: ({ element, node }) => {
    var _a, _b;
    const anchorDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.ANCHOR
    );
    return decorator(anchorDecoration, element);
  }
};

const nodeViewDecorators = [
  LinkDecorator,
  AnchorDecorator
];

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginLink = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: LINK_TYPE,
    typeMapper,
    nodeViewDecorators
  };
};

export { LINK_TYPE, LinkViewer$1 as LinkViewer, typeMapper as linkTypeMapper, pluginLink };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-link/dist/es/styles.viewer.min.global.css'